import React from "react";
import { Link } from "react-router-dom";
import { Cloud, Flame, ArrowRight } from "lucide-react";

export default function DataCloudTrackCard({ stats }) {
  const pct = stats ? Math.round((stats.completed_count / stats.total_days) * 100) : 0;

  return (
    <Link
      to="/roadmap"
      data-testid="dashboard-datacloud-track-card"
      className="group relative rounded-[18px] border border-[#232d42] bg-[#131a29] p-5 pt-6 block transition-all duration-300 hover:-translate-y-1 hover:border-[#5b9dff]/60 hover:shadow-[0_12px_40px_rgba(91,157,255,0.15)] overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-[3px] bg-[#5b9dff]" />
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Cloud className="w-4 h-4 text-[#5b9dff]" />
          <span className="text-xs font-bold uppercase tracking-wider text-[#5b9dff]">Data Cloud Track</span>
        </div>
        {stats && stats.streak_current > 0 && (
          <span className="flex items-center gap-1 text-[11px] font-bold font-mono text-[#5b9dff]" data-testid="dashboard-datacloud-streak">
            <Flame className="w-3 h-3" /> {stats.streak_current}
          </span>
        )}
      </div>
      <p className="text-sm font-semibold text-[#eef1f8]">Data Cloud 30-Day Challenge</p>
      <p className="text-xs text-[#8993ab] mt-1">Ingestion, Identity Resolution, Calculated Insights & Activation</p>
      <div className="w-full h-1.5 bg-[#1b2434] rounded-full overflow-hidden mt-4">
        <div className="h-full bg-[#5b9dff] rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-[11px] font-mono text-[#8993ab]">{stats ? `${stats.completed_count}/${stats.total_days} days` : "Loading..."}</span>
        <span className="text-[11px] font-semibold text-[#5b9dff] flex items-center gap-1 group-hover:gap-1.5 transition-all">
          {stats?.completed_count > 0 ? "Continue" : "Start"} <ArrowRight className="w-3 h-3" />
        </span>
      </div>
    </Link>
  );
}
